















































































































































































































import Vue from 'vue';
// @ts-ignore
import ClickOutside from 'vue-click-outside';
import utils from '~/plugins/utilities';
import Dialog from '~/components/Dialog.vue';
import LangPicker from '~/components/LangPicker.vue';
import FirstTimeDialog from '~/components/FirstTimeDialog.vue';
import DialogMixin from '~/layouts/dialog.vue';

export default Vue.extend({
  components: {
    Dialog,
    LangPicker,
  },
  directives: {
    ClickOutside,
  },
  mixins: [DialogMixin],
  data() {
    return {
      isMenuOpen: false,
    };
  },
  watch: {
    $route() {
      if (!this.$router.currentRoute.fullPath.startsWith('/guide')) {
        document.body.classList.remove('v-tour--active');
      }
    },
  },
  mounted() {
    this.$root.$on('finish-guide', this.setGuideViewed);
    this.$nextTick(() => {
      if (!this.isGuideViewed() && !this.$route?.query?.fk) {
        this.openGuideModal();
      }
    });
  },
  destroyed() {
    this.$root.$off('finish-guide');
  },
  methods: {
    logout() {
      this.$cookies.remove('auth');
      this.$forceUpdate();
      this.$router.push((this as any).localePath('/login'));
    },
    toggleMenuDropdown() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenuDropdown() {
      this.isMenuOpen = false;
    },
    getCurrentPage() {
      return utils.getCurrentPage({ route: this.$route });
    },
    getSupportPhoneNumber() {
      const country = this.$store.state?.auth?.company?.country;
      if (country === 'PL') {
        return '+48732080171';
      } else {
        return '+37064721799';
      }
    },
    openGuideModal() {
      this.$root.$emit(
        'open-dialog',
        {
          component: FirstTimeDialog,
          title: this.$t('firstTimeDialog.header'),
        },
        {
          onClose: this.setGuideViewed,
        }
      );
    },
    setGuideViewed() {
      this.$cookies.set(
        'guide',
        { viewed: true },
        {
          path: '/',
          maxAge: 60 * 60 * 24 * 365,
        }
      );
    },
    isGuideViewed() {
      const guide = this.$cookies && this.$cookies.get('guide');
      return (guide && guide.viewed) || false;
    },
  },
});
